import { useGetAllAccounts } from '@/api/generated/accounts/accounts';
import { usePlansList } from '@/features/planning';
import { sumAnnualIncomeFromRecurrentPayments } from '@/features/planning/recurrentPayments';
import { useMemo } from 'react';
import { computeCheckingBalance } from './checkingBalance';

export function useBankingHeroMetrics() {
  const { data: accountsResponse, isLoading: accountsLoading } = useGetAllAccounts();
  const { plans, isLoading: plansLoading } = usePlansList();

  const accounts = useMemo(() => accountsResponse?.items ?? [], [accountsResponse]);
  const checkingBalance = useMemo(() => computeCheckingBalance(accounts), [accounts]);

  const defaultPlan = useMemo(() => plans.find((plan) => plan.isDefault) ?? plans[0], [plans]);

  const monthlySalary = useMemo(() => {
    if (!defaultPlan?.assumptions) return 0;
    return sumAnnualIncomeFromRecurrentPayments(defaultPlan.assumptions) / 12;
  }, [defaultPlan]);

  return {
    checkingBalance,
    monthlySalary,
    isLoading: accountsLoading || plansLoading,
  };
}
